/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query GetDistrictClasses {
    me {
      id
      company {
        id
        districtClasses
      }
    }
  }
`): DocumentNode);
